import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { BetEventModel } from '@shared/types';

import { useCreateBetEventMutation } from '@services';

import { AppDispatch, setBetEvent } from '@store';

import { BetEventForm, BetEventFormValues, INITIAL_BET_EVENT_VALUES } from '../../../BetSystemSettingsForms';

import { BetEventCreateModalProps } from './types';

export const BetEventCreateModal: FC<BetEventCreateModalProps> = ({ isOpened, handleClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [createBetEvent, { isLoading: isCreatingInProgress }] = useCreateBetEventMutation();

  const handleCreateBetEvent = async (values: BetEventFormValues) => {
    const { startDate, ...restValues } = values;

    const createdBetEvent = await createBetEvent({
      ...restValues,
      startDate: startDate.format(),
    } as Omit<BetEventModel, 'status'>).unwrap();

    dispatch(setBetEvent(createdBetEvent));

    toast.success('Success: Bet event has been created!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Create Event" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <BetEventForm
        initialValues={INITIAL_BET_EVENT_VALUES}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateBetEvent}
      />
    </BaseModal>
  );
};
